import { config } from '@config';
import { useGetCurrentUser } from '@queries/users.query';
import { initializeGoogleAnalytics } from '@utils/google-analytics.util';
import { PostHogProvider } from 'posthog-js/react';
import type React from 'react';
import { useEffect } from 'react';

type AnalyticsProviderProps = {
  children: React.ReactNode;
};

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = (props) => {
  const { children } = props;
  const { data: user, isPending } = useGetCurrentUser();

  const isImpersonating = Boolean(user?.impersonation);

  useEffect(() => {
    if (isPending) return;

    if (!isImpersonating) {
      initializeGoogleAnalytics();
    }
  }, [isImpersonating, isPending]);

  if (!config.posthog?.apiKey || isImpersonating || isPending) {
    return <>{children}</>;
  }

  return (
    <PostHogProvider
      apiKey={config.posthog.apiKey}
      options={{ api_host: 'https://us.i.posthog.com' }}
    >
      {children}
    </PostHogProvider>
  );
};
